import { motion } from "framer-motion";
import { Spinner } from "../components/Spinner";

export function LoadingComponent({ message = "Fetching data...", compact = false }) {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center justify-center"
      >
        {/* Animated background circle */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            delay: 0.1,
            type: "spring",
            stiffness: 200,
            damping: 15,
          }}
          className="relative"
        >
          {/* Outer pulsing ring */}
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.1, 0.3],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className={`absolute inset-0 ${compact ? "w-12 h-12" : "w-16 h-16"} -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 rounded-full bg-gray-900/10`}
          />

          {/* Main spinner container */}
          <div className={`relative ${compact ? "w-12 h-12" : "w-16 h-16"} rounded-full bg-white shadow-lg flex items-center justify-center`}>
            <Spinner size={compact ? "md" : "lg"} className="text-gray-900" />
          </div>
        </motion.div>

        {/* Loading text */}
        {message && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className={`${compact ? "mt-3" : "mt-4"} text-center`}
          >
            <p className={`${compact ? "text-sm" : "text-base"} font-medium text-gray-700`}>{message}</p>
          </motion.div>
        )}

        {/* Decorative dots - only show when not compact */}
        {!compact && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-4 flex items-center justify-center gap-1.5"
          >
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: 0,
              }}
              className="w-1.5 h-1.5 rounded-full bg-gray-300"
            />
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: 0.2,
              }}
              className="w-1.5 h-1.5 rounded-full bg-gray-400"
            />
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: 0.4,
              }}
              className="w-1.5 h-1.5 rounded-full bg-gray-300"
            />
          </motion.div>
        )}
      </motion.div>
    </div>
  );
}
